module.exports = __webpack_public_path__ + "img/floor_1_right.1fa89e82.jpg";